import { render, staticRenderFns } from "./FazendaProfile.vue?vue&type=template&id=198891e9"
import script from "./FazendaProfile.vue?vue&type=script&lang=js"
export * from "./FazendaProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports